module.exports = __webpack_public_path__ + "img/new_terms_new_icon.ee7e047.png";